// ---------------------------------------------------------------------------
// The countdown in the masthead, ticking.
//
// The server renders the four figures as they stand when the page is built, so
// a reader without JavaScript still gets a true snapshot. This keeps it true:
// every second, the same four cells, recounted from the same moment.
//
// Not a Vue island. There is no state to share and no markup to build — eight
// text nodes change on a timer, and a component around that would be
// scaffolding for its own sake.
// ---------------------------------------------------------------------------

const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

const SPANS = [DAY, HOUR, MINUTE, SECOND]

/** One, a few, many — the three Czech forms, in that order. */
const decline = (count, forms) => forms[count === 1 ? 0 : count > 1 && count < 5 ? 1 : 2]

export function countdown() {
    const node = document.querySelector('[data-countdown]')

    if (!node) return

    const target = Date.parse(node.dataset.countdown)
    const cells = [...node.querySelectorAll('.countdown__cell')].map((cell) => ({
        value: cell.querySelector('[data-part]'),
        unit: cell.querySelector('[data-forms]')
    }))

    if (Number.isNaN(target) || cells.length !== SPANS.length) return

    const tick = () => {
        const left = Math.max(target - Date.now(), 0)

        cells.forEach((cell, index) => {
            const span = SPANS[index]
            const count = Math.floor((index ? left % SPANS[index - 1] : left) / span)

            cell.value.textContent = count
            cell.unit.textContent = decline(count, cell.unit.dataset.forms.split('|'))
        })

        // On the second, not every thousand milliseconds after load: a timer
        // that drifts shows the same number twice and then skips one.
        if (left > 0) window.setTimeout(tick, SECOND - (Date.now() % SECOND))
    }

    tick()
}
